<template>
  <div ref="stockTemplateEditor">
    <div class="row">
      <div class="col-lg-12">
        <NestableTable :columns="columnList" v-model="templateItemList" @update="templateUpdated()" :editing="editing" hoverRows borderedRows>
          <template v-slot:rowSlot="slotProps">
            <NestableTableRow :editing="editing">
              <NestableTableCell :index="0" :columns="columnList" :class="{'font-weight-bold': slotProps.nestLevel == 0}" :showNesting="slotProps.nestLevel">
                <FormSelect placeholder="Stock Type" v-model="slotProps.item.stockType" @input="itemUpdated(slotProps.item)" field="stockType" :options="itemStockTypeOptions(slotProps.item)" v-show="editing" />
                <span v-if="!editing">{{getLookupName(stockTypeOptions, slotProps.item.stockType)}}</span>
              </NestableTableCell>
              <NestableTableCell :index="1" :columns="columnList">
                <FormSearchableSelect :options="stockListForType(slotProps.item.stockType)" v-model="slotProps.item.stockId" @input="itemUpdated(slotProps.item)" placeholder="Stock Code" :loading="false" :dropdownAutoWidth="true" v-show="editing" />
                <span v-if="!editing">{{stockCodeLookup(slotProps.item)}}</span>
              </NestableTableCell>
              <NestableTableCell :index="2" :columns="columnList">
                <template v-if="!editing">{{itemPricingGroupList(slotProps.item)}}</template>
                <FormMultiSelect v-if="editing && isItemGlass(slotProps.item)" :value="slotProps.item.pricingGroupList" @input="slotProps.item.pricingGroupList = $event; itemUpdated(slotProps.item)" :options="glassPriceGroupOptions" placeholder="Select Price Groups" />
              </NestableTableCell>
              <NestableTableCell :index="3" v-if="editing" :columns="columnList">
                <ActionDropMenu buttonClass="btn-white btn-xs" title="Action" :tableAction="true">
                  <DropdownMenuItem @click="removeRow(slotProps.item.id)" icon="fa-trash-alt">Remove</DropdownMenuItem>
                  <DropdownMenuItem v-if="isItemGlass(slotProps.item)" @click="addSubItem(slotProps.item.id)" icon="fa-plus-circle">Add Sub Item</DropdownMenuItem>
                </ActionDropMenu>
              </NestableTableCell>
            </NestableTableRow>
          </template>
        </NestableTable>
        <br />
        <ActionButton type="new" class="btn-xs" @click="addNewRow" v-if="editing"> Add Row</ActionButton>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import * as Types from '@/store/types'
import Utils from '@/utils/utils'
import form from '@/mixins/form.js'
import NestableTable from '@/components/table/nestableTable'
import NestableTableCell from '@/components/table/nestableTableCell'
import NestableTableRow from '@/components/table/nestableTableRow'

import { InventoryStockTypes, InventoryStockTypeLookup, UOMTypes, UOMTypeLookup, GlassTypes, GlassTypeTypeLookup } from '@/store/types'

export default {
  name: "StockTemplateEditor",
  mixins: [form],
  components: {
    NestableTable,
    NestableTableCell,
    NestableTableRow
  },
  props: {
    templateList: Array,
    editing: Boolean
  },
  watch: {
    templateList: function(newVal, oldVal) {
      this.$data.templateItemList = this.populateList(newVal)
    }    
  },
  computed: {
    glassPriceGroupOptions() {
      return this.$data.glassPriceGroupList.map(priceGroup => {
        return {
          value: priceGroup.id,
          name: priceGroup.name
        }
      })
    },
    columnList() {
      var columnList = [
        { title: 'Stock Type', width: '20%' },
        { title: 'Stock Item', width: '30%' },
        { title: 'Pricing Groups', width: '40%' }
      ]
      if(this.editing)
        columnList.push({ title: 'Actions', width: '10%' })
      return columnList
    }
  },
  created() {
    this.InventoryStockTypes = InventoryStockTypes
  },
  mounted() {
    this.$apiService.pricingService.getStockPriceGroupList().then(response => {
      this.$data.glassPriceGroupList = response.data
    })
    this.$apiService.inventoryService.getStockList().then(response => {
      this.$data.stockList = response.data.filter(stock => stock.isActive)
    })

    this.$data.templateItemList = this.populateList(this.$props.templateList)
  },
  methods: {
    addNewRow() {
      this.$data.templateItemList.push({
        id: this.$data.currentId++,
        stockType: InventoryStockTypes.glass,
        stockId: null,
        isChild: false,
        pricingGroupList: [],
        childItems: []
      })
      this.templateUpdated()
    },
    removeRow(id) {
      this.$data.templateItemList = this.removeItem(this.$data.templateItemList, id)
      
      this.templateUpdated()
    },
    removeItem(list, id) {
      if(list == null)
        return list
      
      let itemIndex = list.findIndex(item => item.id == id)
      if(itemIndex != -1) {
        list.splice(itemIndex, 1)
        return list
      }
      list.forEach(item => {
        item.childItems = this.removeItem(item.childItems, id)
      })
      return list
    },
    addSubItem(id) {
      var itemIndex = this.$data.templateItemList.findIndex(item => item.id == id)
      if(itemIndex >= 0) {
        var item = this.$data.templateItemList[itemIndex]

        if(!item.childItems)
          item.childItems = []

        item.childItems.push({
          id: this.$data.currentId++,
          stockType: InventoryStockTypes.glassService,
          stockId: null,
          isChild: true,
          pricingGroupList: []
        })

        this.$set(this.$data.templateItemList, itemIndex, item)
      }
      this.templateUpdated()
    },
    itemPricingGroupList(item) {
      if(item.stockType != InventoryStockTypes.glass)
        return 'N/A'

      return _.compact(item.pricingGroupList.map(priceGroupId => {
        var priceGroup = this.$data.glassPriceGroupList.find(group => group.id == priceGroupId)
        if(priceGroup)
          return priceGroup.name
        return null
      })).join(', ')
    },
    orderUpdated(orderIds) {
      if(!_.isArray(orderIds))
        return

      this.$data.templateItemList = _.compact(orderIds.map(id => {
        return this.$data.templateItemList.find(item => item.id == id)
      }))

      this.templateUpdated()
    },
    itemUpdated(item, list = null) {
      if(list == null)
        list = this.$data.templateItemList

      list.forEach((listItem, index) => {
        if(listItem.id == item.id) {
          list[index] = item
          this.$emit('update', this.templateItemList)
        } else {
          if(listItem.childItems)
            this.itemUpdated(item, listItem.childItems)
        }
      })
    },
    templateUpdated() {
      this.$emit('update', this.templateItemList)
    },
    populateList(itemList, isChild = false) {
      // Bump id
      if(_.isArray(itemList)) {
        return itemList.map(item => {
          this.$data.currentId = Math.max(this.$data.currentId, item.id+1)

          var output = {
            id: item.id,
            stockType: item.stockType,
            stockId: item.stockId,
            pricingGroupList: item.pricingGroupList,
            isChild: isChild,
            childItems: this.populateList(item.childItems, true),
          }
          return output
        })
      }
      return []
    },
    stockListForType(stockType) {
      return this.$data.stockList.filter(stock => stock.type == stockType).map(stock => {
        return {
          value: stock.id,
          name: `${stock.code} | ${stock.name}`
        }
      })
    },
    stockCodeLookup(templateItem) {
      var name = this.getLookupName(this.stockListForType(templateItem.stockType), templateItem.stockId)
      if(name == null || name == '')
        return 'Empty'
      return name
    },
    isItemGlass(templateItem) {
      return templateItem.stockType == InventoryStockTypes.glass
    },
    isItemChild(templateItem) {
      return templateItem.isChild
    },
    itemStockTypeOptions(templateItem) {
      // Child items cannot use glass
      return InventoryStockTypeLookup.filter(lookup => {
        if(lookup.value == InventoryStockTypes.template || lookup.value == InventoryStockTypes.assembly)
          return false
        if(lookup.value == InventoryStockTypes.glass && templateItem.isChild)
          return false
        return true
      })
    }
  },
  data() {
    return {
      currentId: 1,
      stockList: [],
      stockTypeOptions: InventoryStockTypeLookup.filter(lookup => lookup.value != InventoryStockTypes.template && lookup.value != InventoryStockTypes.assembly),   // Can't recursively add templates/assemblies
      templateItemList: [],
      glassPriceGroupList: []
    }
  },
  
}
</script>